import { MeterApiEndpoints } from '@contracts';

export const METER_ENDPOINTS: MeterApiEndpoints = {
  list: {
    path: 'meters',
    domain: 'core',
    version: 'v1',
  },
  info: {
    path: 'meters/info/',
    domain: 'core',
    version: 'v1',
  },
  create: {
    path: 'meters',
    domain: 'core',
    version: 'v1',
  },
  update: {
    path: `meters/`,
    domain: 'core',
    version: 'v1',
  },
  delete: {
    path: `meters`,
    domain: 'core',
    version: 'v1',
  },
  testSync: {
    path: 'meters/test-sync',
    domain: 'core',
    version: 'v1',
  },

  brands: {
    path: 'get/brands',
    domain: 'core',
    version: 'v1',
  },
  panels: {
    path: 'panels/',
    domain: 'core',
    version: 'v1',
  },
  loops: {
    path: 'get/loops',
    domain: 'core',
    version: 'v1',
  },
  tags: {
    path: 'tags',
    domain: 'core',
    version: 'v1',
  },
  tenants: {
    path: 'tenants',
    domain: 'core',
    version: 'v1',
  },
  locations: {
    path: 'locations',
    domain: 'core',
    version: 'v2',
  },
  publicUnits: {
    path: 'get/public-unit',
    domain: 'core',
    version: 'v1',
  },
  groups: {
    path: 'get/groups',
    domain: 'core',
    version: 'v1',
  },
};
